import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { DepositRegisterContainerModel } from '../../../../../models/aggregates/deposit-register';
import { DepositRegisterRolloverDto } from '../../../../../models/aggregates/deposit-register';
import { Observable } from 'rxjs';
import { BasicApiResponseModel } from '../shared/api-response.model';
import { ApiVisa } from '../shared';
import { BaseApiPublicLoginTemplateService } from '../shared/base-api-public-login-template.service';

@Injectable({
  providedIn: 'root'
})
export class DepositRegisterService extends BaseApiPublicLoginTemplateService<DepositRegisterContainerModel,DepositRegisterContainerModel,DepositRegisterContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'deposit-register-hdrs/' + BaseApiTemplateService.BACKOFFICE_EP;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'deposit-register-hdrs/' + BaseApiTemplateService.BACKOFFICE_EP;
    this.endpoint_path_login_entity_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'deposit-register-hdrs/' + BaseApiTemplateService.LOGIN_ENTITY_EP;
    this.endpoint_path_public_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'deposit-register-hdrs/' + BaseApiTemplateService.PUBLIC_EP;
    this.httpClient = http;
  }
  
  public createTemp(dtoObject: DepositRegisterContainerModel, visa: ApiVisa): Observable<BasicApiResponseModel<DepositRegisterContainerModel>>{
    if (visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'deposit-register-hdrs/temp/' + BaseApiTemplateService.BACKOFFICE_EP;
    }else{
      this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'deposit-register-hdrs/temp/' + BaseApiTemplateService.BACKOFFICE_EP;
    }
    return this.httpClient.post<BasicApiResponseModel<DepositRegisterContainerModel>>(
      this.apiUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  public createRollover(guid: string, visa: ApiVisa): Observable<BasicApiResponseModel<DepositRegisterContainerModel>> {
    if (visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'deposit-register-hdrs/create-rollover/' + BaseApiTemplateService.BACKOFFICE_EP + '/' + guid;
    } else {
      this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'deposit-register-hdrs/create-rollover/' + BaseApiTemplateService.BACKOFFICE_EP + '/' + guid;
    }
    return this.httpClient.post<BasicApiResponseModel<DepositRegisterContainerModel>>(
      this.apiUrl,
      {},
      this.getHttpHeader(visa)
    );
  }

  public getDepositCalculations(
    container: DepositRegisterContainerModel,
    visa: ApiVisa
  ): Observable<BasicApiResponseModel<DepositRegisterRolloverDto>> {
    
    if (visa.api_domain_url) {
      this.apiUrl =
        visa.api_domain_url +
        Core2Config.TENANT_DOMAIN_URL_PREFIX +
        Core2Config.ERP_PREFIX +
        Core2Config.FI_PREFIX +
        'deposit-register-hdrs/deposit-calculations/' +
        BaseApiTemplateService.BACKOFFICE_EP;
    } else {
      this.apiUrl =
        Core2Config.DOMAIN_URL +
        Core2Config.TENANT_DOMAIN_URL_PREFIX +
        Core2Config.ERP_PREFIX +
        Core2Config.FI_PREFIX +
        'deposit-register-hdrs/deposit-calculations/' +
        BaseApiTemplateService.BACKOFFICE_EP;
    }

    return this.httpClient.post<BasicApiResponseModel<DepositRegisterRolloverDto>>(
      this.apiUrl,
      container, // <── send container instead of {}
      this.getHttpHeader(visa)
    );
  }

}